<template>
  <div class="grey lighten-5 fill-height">
    <NewResetPassword />
    <toaster />
  </div>
</template>
<script>
import NewResetPassword from '/src/components/pages/ResetPassword/new'
import Toaster from '@/components/commons/Toaster'

export default {
  components: { NewResetPassword, Toaster }
}
</script>
